import {PageSubContainerSkeleton} from "@project/components/feedback";
import {Skeleton} from "@project/design-system-web";

export function UserPermissionsPending() {
  return (
    <PageSubContainerSkeleton>
      <Skeleton className="h-6 w-40 rounded-md" />
      <Skeleton className="h-5 w-64 rounded-md" />
    </PageSubContainerSkeleton>
  );
}
